import React from "react";
import EntryExitOption from "./EntryExitOption";
import { useTranslation } from "react-i18next";
import DropDownMenuProfile from "../../../../../components/DropDown/DropDownMenuProfile";
import DropDownMenuItem from "../../../../../components/DropDown/DropDownMenuItem";
import TableFunction from "../../../../../components/table/TableFunction";
import {DownArrowIcon} from "../../../../../components/buttons/IconButtons";

/**
 * @Author      Karen Yunuen Pozos Arias
 * @JobTitle    FullStack
 * @Email       kpozos@ibl.mx
 * @param {Object} props - Component props.
 * @param {string} props.day - Display label for the day (e.g., "Mon 09", "2025-12-09").
 * @param {string} props.color - Base color used to style attendance records (e.g., hex, CSS variable).
 * @param {Array<{ userId?: string, id?: string, entries: Array<Object> }>} [props.rows=[]]
 *        List of user attendance records.
 *        Each item must include:
 *          - `userId` or `id`: Unique user identifier.
 *          - `entries`: Array of entry/exit records (at least one expected).
 *
 * @param {string} model - Model used to retrieve variables for setting the color.
 * @param {boolean} [showScheduledShift] - Adds the scheduled shift column before the entry one.
 */


const AttendanceDayRecord = ({ day, color, rows=[],model, showScheduledShift = false }) => {
    const { t } = useTranslation()
    const { openMenu, handleMenuToggle, handleClose} = TableFunction({});
    const getActionsButtons = (entries, id) => {
        let aux = entries.slice(1);
        return  (
            <DropDownMenuProfile
                classNameMenu={'overlay-y-auto'}
                openMenu={openMenu}
                handleMenuToggle={handleMenuToggle}
                menuId={`menu-${id}`}
                icon={<DownArrowIcon className={"icon-color-shades-400"}/>}
            >
                { aux?.map((e, index) => (
                    <DropDownMenuItem
                        index={index}
                        handleClose={handleClose}
                    >
                        <EntryExitOption
                            record={e || {}}
                            model={model}
                            color={color}
                            showScheduledShift={showScheduledShift}
                        />
                    </DropDownMenuItem>
                ))
                }
            </DropDownMenuProfile>
        )
    };

    return (
        <div className="attendance-day-record">
            <div className={"attendance-title p-2"}>
                <div className="record-date">{day}</div>

                <div className="entry-exit-option head-content">
                    { showScheduledShift &&
                        <div className="record-col scheduled">
                            <span className={"fs-14px ibl-font-w-600 text-uppercase text-nowrap"}>{t('scheduled_shift')}</span>
                        </div>
                    }
                    <div className="record-col in"><span className={"fs-14px ibl-font-w-600 text-uppercase"}>{t('in')}</span></div>
                    <div className="record-col out"><span className={"fs-14px ibl-font-w-600 text-uppercase"}>{t('out')}</span></div>
                    <div className="record-col center-symbol" />
                    <div className="record-col duration" />
                    <div className="record-col arrow" />
                </div>
            </div>

            <div className="d-flex flex-column">
                {rows.map((row, idx) => {
                    const firstEntry = row.entries[0];
                    const userId = row.userId || row.id
                    return (
                        <div
                            key={userId}
                            className={`record-row ${rows.length-1 === idx ? "mb-0": "mb-16px"}`}
                        >
                            <EntryExitOption
                                record={firstEntry || {}}
                                model={model}
                                showScheduledShift={showScheduledShift}
                                getActionsButtons={
                                    row.entries.length > 1
                                        ? (e) => getActionsButtons(row.entries, userId)
                                        : null
                                }
                                color={color}
                            />
                        </div>
                    ) })}
            </div>
        </div>
    );
};

export default AttendanceDayRecord;
